import api from './api';

export async function startWorkflowExecution(workflowId: string, sessionId: string) {
  const response = await api.post(`/workflows/${workflowId}/execute`, { session_id: sessionId });
  return response.data;
}

export async function getWorkflowExecution(executionId: string) {
  try {
    if (!executionId) {
      console.error("getWorkflowExecution called with empty executionId");
      return null;
    }
    
    const response = await api.get(`/workflows/executions/${executionId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching workflow execution ${executionId}:`, error);
    return null;
  }
}

export async function updatePhaseStatus(
  executionId: string, 
  phaseId: string, 
  status: 'not_started' | 'in_progress' | 'completed' | 'failed' | 'skipped'
) {
  const response = await api.patch(
    `/workflows/executions/${executionId}/phases/${phaseId}`,
    { status }
  );
  return response.data;
}

export async function createPhaseArtifact(
  executionId: string,
  phaseId: string,
  artifactData: {
    name: string;
    type: string;
    content: any;
    created_by?: string;
  }
) {
  const response = await api.post(
    `/workflows/executions/${executionId}/phases/${phaseId}/artifacts`,
    artifactData
  );
  return response.data;
}

export async function recordAgentActivity(
  executionId: string,
  phaseId: string,
  activityData: {
    agent_id: string;
    persona_id: string;
    action: string;
    details?: any;
  }
) {
  const response = await api.post(
    `/workflows/executions/${executionId}/phases/${phaseId}/agent_activity`,
    activityData
  );
  return response.data;
}

export async function getWorkflowExecutions(workflowId: string) {
  try {
    if (!workflowId) {
      console.error("getWorkflowExecutions called with empty workflowId");
      return [];
    }
    
    const response = await api.get(`/workflows/${workflowId}/executions`);
    
    // Only log when we find executions or errors
    if (response.data?.length > 0) {
      console.log(`[WORKFLOW-SERVICE] Found ${response.data.length} executions for workflow ${workflowId}`);
    }
    
    return response.data || [];
  } catch (error) {
    console.error(`[WORKFLOW-SERVICE] Error fetching executions for workflow ${workflowId}:`, error.message);
    return [];
  }
}
